import { IFilter, IRangeFilter, IStringFilter } from 'app/shared/model/filter.model';
import { Moment } from 'moment';
export const enum AuditState {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  WAITING = 'WAITING'
}
// 列表
export interface ITableType {
  id?: string | number;
  name?: string; // 客户
  phone?: string; // 电话
  status?: number; // 状态
  house?: string; // 房源
  reporter?: string; // 报备人
  reporterType?: string; // 报备人类型
  company?: string; // 所属公司
  reportingTime?: Moment; // 报备时间
  dealTime?: string; // 成交时间
  contractCode?: string; // 合同编号
  commission?: string; // 佣金
  createDate?: string; // 成交时间
  fyDealInfoLogs?: any;
  imgs?: any; // 邀约图片
  type?: string; // 报备类型（个人/团租）
}

export const defaultValue: Readonly<ITableType> = {};

// 搜索表单
export interface ISearchForm {
  name?: string;
  phone?: string;
  reporter?: string;
  status?: string;
  reporterType?: string;
  reporterTypes?: any[];
  houseId?: string;
  company?: string;
  reportingTime?: IRangeFilter;
  type?: string;
}

export const defaultSearchForm: ISearchForm = {
  name: '',
  phone: '',
  reporter: '',
  status: '',
  reporterType: '',
  houseId: '',
  company: '',
  reportingTime: {
    lessOrEqualThan: '',
    lessThan: '',
    greaterOrEqualThan: '',
    greaterThan: ''
  },
  type: ''
};
